import { render, staticRenderFns } from "./SelectedFindingsDetails.vue?vue&type=template&id=59bc5d20&"
import script from "./SelectedFindingsDetails.vue?vue&type=script&lang=js&"
export * from "./SelectedFindingsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports